import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gmail.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-121d1b20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register" }
const _hoisted_2 = { class: "signup" }
const _hoisted_3 = { class: "organization" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Sign in to Sixliv", -1))
const _hoisted_5 = { class: "form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Account", -1))
const _hoisted_7 = { class: "inputWrapper" }
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = { class: "form" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "verify_label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Password"),
  /*#__PURE__*/_createElementVNode("span", { class: "sent" }, "Forgot?")
], -1))
const _hoisted_11 = { class: "inputWrapper" }
const _hoisted_12 = { class: "form" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, null, -1))
const _hoisted_14 = { class: "inputWrapper" }
const _hoisted_15 = { class: "join" }
const _hoisted_16 = { class: "registerAccount" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "registerAccount" }, "OR", -1))
const _hoisted_18 = { class: "buttons" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, "Gmail")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.visible,
    center: "",
    width: "416px",
    style: {"height":"512px","border-radius":"16px"},
    "modal-class": "new-modal-class",
    "append-to-body": true,
    "append-to": "body",
    "before-close": _ctx.handleCloseLogin
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event)),
                  class: "input",
                  placeholder: "Please input Email"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.isValidEmail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.isValidEmail), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: _ctx.formData.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event)),
                  class: "input",
                  placeholder: "Please input Password"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_el_button, {
                    loading: _ctx.loading,
                    onClick: _ctx.handleSubmit,
                    class: "button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Sign In")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createTextVNode(" Don’t have an account? "),
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleToOpenRegister && _ctx.handleToOpenRegister(...args))),
                class: "hightText"
              }, "Sign Up")
            ]),
            _hoisted_17
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_ElButton, {
            class: "button",
            onClick: _ctx.handleLogin
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "before-close"]))
}